import { useQuery } from "@apollo/client/react";

import { getFragmentData } from "@/generated/graphql";
import {
  ActivityFragmentDoc,
  GetConfigDocument,
  UserCategoryFragmentDoc,
  UserFeelingFragmentDoc,
} from "@/generated/graphql/graphql";

export function useConfig() {
  const { data } = useQuery(GetConfigDocument);

  const activities = getFragmentData(ActivityFragmentDoc, data?.activities || []);
  const userCategories = getFragmentData(UserCategoryFragmentDoc, data?.userCategories || []);
  const userFeelings = getFragmentData(UserFeelingFragmentDoc, data?.userFeelings || []);

  return { activities, userCategories, userFeelings };
}
